import { getAuth } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { fs } from '../firebase';

const saveAddressOnSuccess = async () => {
    const user = getAuth().currentUser;
    if (!user) return;

    try {
        const raw = localStorage.getItem('confirmedDeliveryAddress');
        if (!raw) return;
        const location = JSON.parse(raw);
        if (!location?.address || !location?.lat || !location?.lng) return;

        const newEntry = { address: location.address, lat: location.lat, lng: location.lng, id: Date.now() };
        const ref = doc(fs, 'users', user.uid);
        const snap = await getDoc(ref).catch(() => null);
        const existing = snap?.exists() ? (snap.data().savedAddresses || []) : [];
        const updated = [newEntry, ...existing.filter(a => a.address !== newEntry.address)].slice(0, 5);
        await setDoc(ref, { savedAddresses: updated }, { merge: true });
    } catch {}
};

export default saveAddressOnSuccess;
